import { boxShadow, color } from '@upstox/upstox-ui';

export const container: CSSFunction = ({ theme }) => ({
  width: '330px',
  padding: '16px',
  gap: '8px',
  backgroundColor: theme.colors.background.default,
  flexDirection: 'column',
  border: `1px solid ${color(theme, 'ui3')}`,
  borderLeft: `4px solid ${theme.colors.interactive.primary.default}`,
  boxShadow: boxShadow(theme, theme.modals.boxShadow),
});

export const closeIcon: CSSFunction = ({ theme }) => ({
  cursor: 'pointer',
  height: '24px',
  width: '24px',
  color: color(theme, 'icon1'),
});

export const actionButton: CSSFunction = () => ({
  padding: 0,
  border: 'none',
  borderRadius: 0,
});
